import { Label } from 'src/components/FormComponents/Input';
import { useLicenceInfo } from 'src/view/hooks/organization';
import { useTranslation } from 'react-i18next';

export const OrganizationLicenceUsage = () => {
    const { licenceInfo } = useLicenceInfo();
    const { t } = useTranslation();

    return (
        <div id="Licences">
            <Label label={t('profile.organization.sectionTitle')} />
            <div className="flex min-h-[42px] items-center rounded-12px border-1.6px border-woodyBrown bg-woodyBrown px-4 py-1 text-white">
                <div className="flex min-w-0 items-baseline gap-1 whitespace-nowrap">
                    <span className="text-xl font-semibold text-peachOrange">
                        {licenceInfo?.active ?? '—'}
                    </span>
                    <span className="text-lg">/</span>
                    <span className="text-lg">{licenceInfo?.total ?? '—'}</span>
                    <span className="ml-1 text-sm text-lightPeach text-opacity-75">
                        {t('profile.organization.usageSuffix')}
                    </span>
                </div>
            </div>
        </div>
    );
};
